// extracted by mini-css-extract-plugin
export default {"container":"mainLayoutComponent_container__hc6PD","containerOrientation":"mainLayoutComponent_containerOrientation__pfih5","asideAd":"mainLayoutComponent_asideAd__aEf3N"};